import { render, staticRenderFns } from "./DownloadDocument.vue?vue&type=template&id=e6b9d654&"
import script from "./DownloadDocument.ts?vue&type=script&lang=ts&"
export * from "./DownloadDocument.ts?vue&type=script&lang=ts&"
import style0 from "./DownloadDocument.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QIcon,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QIcon,QBtn})
